import React from 'react'
import {Box, Text} from '@chakra-ui/react'
import Link from '../link'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'

const TextAndLink = ({textColor, href, message}) => {
    return (
        <Box textAlign="center">
            <Text textStyle="Regular Small" color={textColor ? textColor : null}>
                <FormattedMessage
                    {...message}
                    values={{
                        textlink: (chunks) => (
                            <Link href={href} isExternal fontSize="sm" color="inherit">
                                {chunks}
                            </Link>
                        )
                    }}
                    color={textColor}
                />
            </Text>
        </Box>
    )
}

export default TextAndLink

TextAndLink.propTypes = {
    textColor: PropTypes.string,
    href: PropTypes.string,
    message: PropTypes.any
}
